/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../utils/ajax';

function getData() {
  return new Promise((resolve) => {
    get('data/structure_aug25.json').then((e) => {
      resolve(JSON.parse(e));
    });
  });
}

function getCurData(state) {
  const { data, type, sex } = state;
  const curObject = data.find((e) => {
    return e.type === type && e.sex === sex;
  });
  console.log('curObject', curObject);
  return {
    curData: [...curObject.data],
    earnLess: curObject.data.map((d) => {
      return d.pc - d.diff;
    }),
    earnMore: curObject.data.map((d) => {
      return 100 - d.pc;
    }),
    totalInGroup: curObject.total,
  };
}

function createSelectOptions(state, metric) {
  const options = state.data[0].data.map((e) => {
    return { value: e.iID, label: e[metric] };
  });
  return options;
}

// Create Thunk
export const fetchData = createAsyncThunk('fetchData', async (thunkAPI) => {
  const d = await getData();
  return d;
});

// Slice
const data = createSlice({
  name: 'data',
  initialState: {
    data: [],
    curData: [],
    earnLess: [],
    earnMore: [],
    type: 'full-time', // full-time, part-time, all
    sex: 'persons', // male, female, persons
    timeframe: 'annual', // annual, weekly
    weeklySelectOptions: [],
    annualSelectOptions: [],
    incomeLevel: 'level0',
    incomeSelectActive: false,
    totalInGroup: 0,
    error: null,
    request: false,
  },
  reducers: {
    setSex: (state, action) => {
      state.sex = action.payload;
      const curObject = getCurData(state);
      state.curData = curObject.curData;
      state.earnLess = curObject.earnLess;
      state.earnMore = curObject.earnMore;
      state.totalInGroup = curObject.totalInGroup;
    },
    setType: (state, action) => {
      state.type = action.payload;
      const curObject = getCurData(state);
      state.curData = curObject.curData;
      state.earnLess = curObject.earnLess;
      state.earnMore = curObject.earnMore;
      state.totalInGroup = curObject.totalInGroup;
    },
    setIncome: (state, action) => {
      state.incomeLevel = action.payload;
      // state.curData = getCurData(state);
      state.incomeSelectActive = true;
    },
    setTimeframe: (state, action) => {
      state.timeframe = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.request = false;
      state.data = action.payload;
      const curObject = getCurData(state);
      state.curData = curObject.curData;
      state.earnLess = curObject.earnLess;
      state.earnMore = curObject.earnMore;
      state.totalInGroup = curObject.totalInGroup;
      state.annualSelectOptions = createSelectOptions(state, 'annual');
      state.weeklySelectOptions = createSelectOptions(state, 'weekly');
    });
    /*
    [fetchData.pending]: (state) => {
      state.request = true;
    },
    [fetchData.fulfilled]: (state, action) => {
      state.request = false;
      state.data = action.payload;
      const curObject = getCurData(state);
      state.curData = curObject.curData;
      state.earnLess = curObject.earnLess;
      state.earnMore = curObject.earnMore;
      state.totalInGroup = curObject.totalInGroup;
      state.annualSelectOptions = createSelectOptions(state, 'annual');
      state.weeklySelectOptions = createSelectOptions(state, 'weekly');
    },
    [fetchData.rejected]: (state) => {
      state.request = false;
    },
    */
  },
});

export default data;
